/**
 * Floating banner shown at the top of the Reader when a range-selection
 * gesture has been armed via the long-press action menu. Prompts the user
 * to tap another ayah to finish the range, or cancel.
 */
export default function RangeArmedHint({ rangeArmedFrom, onCancel }) {
  if (!rangeArmedFrom) return null;
  return (
    <div
      data-testid="range-armed-hint"
      className="fixed top-20 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-4 py-2 rounded-full bg-[#1B4D3E]/95 border border-[#C9A227]/50 shadow-xl text-[#E8D5A3] font-outfit text-sm backdrop-blur-md"
    >
      <span>
        Start:{" "}
        <b>
          {rangeArmedFrom.surah}:{rangeArmedFrom.ayah}
        </b>{" "}
        — tap or hold another ayah to finish
      </span>
      <button
        data-testid="range-armed-cancel"
        onClick={onCancel}
        className="text-[#E8D5A3]/70 hover:text-white text-xs underline"
      >
        Cancel
      </button>
    </div>
  );
}
